import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Form, Button, Card, Alert, Spinner} from 'react-bootstrap';
import RenderizarFoto from '../components/Utils/RenderizarFoto';
import Swal from 'sweetalert2';
import { useProvider, Toast } from '../context/MenuProvider'


const ResetarSenhaConfirma = () => {
  const { uidb64, token } = useParams();
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [userName, setUserName] = useState('');
  const [error, setError] = useState('');
  const [valido, setValido] = useState(false);
  const { site, crudAdmin } = useProvider();
  const { post, loading } = crudAdmin || {};
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    if(e) e.preventDefault();
    if (!newPassword) {
      setError('Por favor, insira uma nova senha.');
      return;
    }
    if (confirmNewPassword !== newPassword) {
      setError('As senhas não coincidem.');
      return;
    }


    try{
      const response = await post({new_password:newPassword}, `/api/password-reset-confirm/${uidb64}/${token}/`);
      if (response){
        Swal.fire({
          icon: 'success',
          title: 'Senha redefinida com sucesso!',
          text: `Sua senha foi alterada. Agora você pode fazer login.`,
        });
        navigate('/login');
      }
    }catch(err){
      setError(err.response?.data?.error || err.message);
    }finally{
      
    }
  };

  const validarToken = async () => {
    const dataToken = {
      uidb64,
      token
    }
    try {
      const response = await post(dataToken, `/api/validar-token/`);
      if(response){
        setValido(response[0].valid);
      }
    }catch(err){
      setError(err.response?.data?.error || err.message)
    }finally{
      
    }
    
  };

  useEffect(() => {
    validarToken();
  }, [uidb64, token]);

  return (
    <>
      <div className="col-auto col-md mx-auto">
        <Card>
          <Card.Body>
            <h2 className="text-center border-dashed-bottom mb-4">{loading?'Redefinição de senha': valido ?'Digite a nova senha':'Redefinição de senha sem sucesso'}</h2>
            <div className="text-center col-4 col-md-3 mx-auto">
              <RenderizarFoto className="img-fluid" alt="Logomarca" src={site?.favicon} />
            </div>
            {loading && <p className="text-center"><Spinner animation="border"/></p>}
            {error && <Alert variant="danger">{error}</Alert>}
            {!loading && !valido && (
              `O link para a recuperação de senha era inválido, possivelmente porque já foi utilizado. Por favor, solicite uma nova recuperação de senha.`
            )}
            {!loading && valido && (
            <>
              <p>Por favor, informe sua nova senha duas vezes para que possamos verificar se você a digitou corretamente.</p>
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="newPassword" className="mb-3">
                  <Form.Label>Nova Senha:</Form.Label>
                  <Form.Control
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="Nova Senha"
                    disabled={!valido}
                  />
                </Form.Group>
                <Form.Group controlId="confirmNewPassword" className="mb-3">
                  <Form.Label>Confirmar Nova Senha:</Form.Label>
                  <Form.Control
                    type="password"
                    value={confirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                    placeholder="Confirmar a nova Senha"
                    disabled={!valido}
                  />
                </Form.Group>
  
                <Button variant="secondary" type="submit" className="w-100" disabled={loading}>
                  Confirmar
                </Button>
                <div className="text-center pt-3">
                  <Link to="/login" className="btn btn-sm w-100 btn-outline-secondary">
                    Login
                  </Link>
                </div>
              </Form>
            </>
            )}
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default ResetarSenhaConfirma;